<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DatePicker from "vue2-datepicker";
export default {
  page: {
    title: "Track Status"
  },
  components: {
    Layout,
    PageHeader,
    DatePicker
  },
  data(){
    return {
      title: "Track Status",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
        {
          text: "Track Status",
          active: true
        }
      ],
      from: new Date(),
      to: new Date(),
      tableData: [],
      filter: '',
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      currentPage: 1,
      loading: false,
      chartOptions: {},
      typeOf: 'chart',
      series: [],
      chartType: 'line'
    }
  },
  watch: {
    from(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getData(this.$store.state.data.selectedCampus.id);
      }
    },
    to(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getData(this.$store.state.data.selectedCampus.id);
      }
    }
  },
  computed: {
    filtered() {
      let data = this.tableData;
      var total = this.currentPage * this.perPage;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          return item.deliveryUnit
            .toUpperCase()
            .includes(this.filter.toUpperCase());
        });
      }
      var currentData = data.slice(total - this.perPage, total);
      if (this.currentPage > 1 && currentData.length == 0) {
        total = (this.currentPage - 1) * this.perPage;
        currentData = data.slice(total - this.perPage, total);
      }
      return currentData;
    },
    rows() {
      let data = this.tableData;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          return item.deliveryUnit
            .toUpperCase()
            .includes(this.filter.toUpperCase());
        });
      }
      return data.length;
    },
  },
  methods: {
    async getData(campusId){
      this.loading = true;
      try {
        const {data: response} = await this.$store.dispatch("dtstrack/GetTrackStats", {
          campusId,
          dateFrom: this.getDate(this.from),
          dateTo: this.getDate(this.to),
          removeLoading: true
        });
        if(response.error){
          this.showToast(response.errorMessage, "error");
          return;
        }
        this.tableData = response;
        this.buildChart(response);
      } catch (error) {
        this.showToast("An error occurred while fetching data.", "error");
      } finally {
        this.loading = false;
      }
    },
    buildChart(data) {
      this.series = [
        { name: 'Track Sent',       data: data.map(d => d.trackSent) },
        { name: 'Incoming Tracks',  data: data.map(d => d.incomingTracks) },
        { name: 'Received Tracks',  data: data.map(d => d.receivedTracks) },
        { name: 'Processed Tracks', data: data.map(d => d.processedTracks) }
      ];
      this.chartOptions = {
        chart: {
          type: 'line',
          height: 420,
          toolbar: { show: false }
        },
        stroke: {
          curve: 'smooth',
          width: 2
        },
        markers: {
          size: 4
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: data.map(d => d.deliveryUnit),
          labels: {
            style: { fontSize: '11px' },
            trim: true
          }
        },
        yaxis: {
          title: { text: 'Count' },
          min: 0
        },
        legend: {
          position: 'top'
        },
        tooltip: {
          shared: true,
          intersect: false
        }
      };
    },
  },
  created() {
    this.getData(this.$store.state.data.selectedCampus.id);
  }
};
</script>
<template>
  <Layout @changeCampus="getData($event.id)">
    <PageHeader :title="title" :items="items" />
      <div class="d-flex justify-content-between mb-3">
        <div class="d-flex gap-1">
          <template v-if="typeOf == 'data'">
            <b-form-input
              v-model="filter"
              placeholder="Search by Delivery Unit"
              class="w-auto"
            ></b-form-input>
            <select v-model="perPage" class="form-select w-auto">
              <option v-for="option in pageOptions" :key="option" :value="option">
                {{ option }}
              </option>
            </select>
          </template>
          <select v-model="typeOf" class="form-select w-100px">
            <option value="data">Data</option>
            <option value="chart">Chart</option>
          </select>
          <select v-model="chartType" class="form-select w-100px" v-if="typeOf == 'chart'">
            <option value="line">Line</option>
            <option value="bar">Bar</option>
          </select>
        </div>
        <div class="d-flex align-items-center">
          <label for="from" class="me-2 mb-0">From:</label>
          <date-picker
            v-model="from"
            :first-day-of-week="1"
            lang="en"
            type="date"
          ></date-picker>
          <label for="to" class="mx-2 mb-0">To:</label>
          <date-picker
            v-model="to"
            :first-day-of-week="1"
            lang="en"
            type="date"
          ></date-picker>
        </div>
    </div>
    <template v-if="typeOf == 'data'">
      <table class="table table-bordered table-striped">
        <thead>
          <tr>
            <th>Delivery Unit</th>
            <th class="text-center">Incoming Tracks</th>
            <th class="text-center">Processed Tracks</th>
            <th class="text-center">Received Tracks</th>
            <th class="text-center">Sent Tracks</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="loading">
            <tr>
              <td colspan="5" class="text-center">
                <b-spinner label="Loading..."></b-spinner>
              </td>
            </tr>
          </template>
          <template v-else>
            <template v-if="tableData.length == 0">
              <tr>
                <td colspan="5" class="text-center">No data available.</td>
              </tr>
            </template>
            <template v-else-if="tableData.length && !filtered.length">
              <tr>
                <td colspan="5" class="text-center">No matching records found.</td>
              </tr>
            </template>
            <template v-else>
              <tr v-for="(item, index) in filtered" :key="index">
                <td class="text-white">{{ item.deliveryUnit }}</td>
                <td class="text-center">{{ item.incomingTracks == 0 ? "-" : item.incomingTracks }}</td>
                <td class="text-center">{{ item.processedTracks == 0 ? "-" : item.processedTracks }}</td>
                <td class="text-center">{{ item.receivedTracks == 0 ? "-" : item.receivedTracks }}</td>
                <td class="text-center">{{ item.trackSent == 0 ? "-" : item.trackSent }}</td>
              </tr>
            </template>
          </template>
        </tbody>
      </table>
      <div class="row">
        <div class="col">
            <div
                class="dataTables_paginate paging_simple_numbers float-end"
            >
                <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                </ul>
            </div>
        </div>
      </div>
    </template>
    <template v-else>
      <template v-if="loading">
        <div class="text-center my-5 py-5">
          <div class="my-5 py-5">
           <b-spinner label="Loading..."></b-spinner>
          </div>
        </div>
      </template>
      <template v-else>
        <template v-if="chartType == 'line'">
          <apexchart
            class="apex-charts"
            type="line"
            dir="ltr"
            height="480"
            :series="series"
            :options="chartOptions"
          ></apexchart>
        </template>
        <template v-else>
          <apexchart
            class="apex-charts"
            type="bar"
            dir="ltr"
            height="480"
            :series="series"
            :options="chartOptions"
          ></apexchart>
          </template>
      </template>
    </template>
  </Layout>
</template>